module.exports = __webpack_public_path__ + "static/bib_home-9c046939b434db83327d280970b1d3c7.jpg";